import PropTypes from 'prop-types';

import SimplePageTemplate from '@spotahome/landings-common/src/components/SimplePageTemplate';
import LinkList from '@spotahome/landings-common/src/components/LinkList';

import './AllSearchList.scss';

const AllSearchList = ({ searchLinkList }) => {
  // eslint-disable-next-line react/prop-types
  const list = searchLinkList.map(({ title, url }) => ({
    id: url,
    title,
    url
  }));

  return (
    <SimplePageTemplate title="Search Sitemap">
      <LinkList className="search-list" list={list} />
    </SimplePageTemplate>
  );
};

AllSearchList.propTypes = {
  searchLinkList: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string
  }).isRequired
};

export default AllSearchList;
